import { isSelectableRoleType, type SelectableRole } from './userConstants';

export const cleanSelectableRoles = (roles: string[]) => {
	return roles.filter((role): role is SelectableRole =>
		isSelectableRoleType(role),
	);
};

export default cleanSelectableRoles;
